// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_70-6";
export var headerCell = "_70-2";
export var loadingStateContent = "_70-8";
export var rowWrapper = "_70-4";
export var stickyAggregationCell = "_70-b";
export var stickyAggregationRow = "_70-7";
export var stickyColumnCell = "_70-a";
export var stickyColumnHeaderCell = "_70-9";
export var table = "_70-1";
export var virtualRowWrapper = "_70-5";
export var virtualTableBodyFiller = "_70-d";
export var virtualTableBodyFillerBottom = "_70-e";
export var virtualTableContainer = "_70-0";
export var virtualTableContainerFill = "_70-c";
export var white = "_70-3";